import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
  name: 'config',
  initialState: {
    showPrices: false
  },
  reducers: {
    showPrices: (state) => ({ ...state, showPrices: true }),
    hidePrices: (state) => ({ ...state, showPrices: false }),
  },
  selectors: {
    selectShowPrices: (state) => state.showPrices
  }
})

export default configSlice.reducer;

export const { showPrices, hidePrices } = configSlice.actions;
export const { selectShowPrices } = configSlice.selectors;